/**
 * Lese-/Entscheidungs-Schicht für die Entdeckt-Inbox (v5_discovery_suggestions).
 */

import { supabase } from '@/lib/supabase';
import type { DiscoveryGruppe } from '@/lib/discovery-universe';

export interface DiscoverySuggestion {
  symbol: string;
  label: string;
  gruppe: DiscoveryGruppe;
  asset_subtype: string | null;
  rs13: number | null;
  rs26: number | null;
  flow_state: string | null;
  score: number | null;
  main_strategy: string | null;
  reason: string | null;
  suggested_date: string;
  status: 'offen' | 'uebernommen' | 'abgelehnt';
}

export async function fetchDiscoverySuggestions(): Promise<DiscoverySuggestion[]> {
  const { data, error } = await supabase
    .from('v5_discovery_suggestions')
    .select('*')
    .eq('status', 'offen')
    .order('score', { ascending: false })
    .limit(12);
  if (error) throw new Error(error.message);
  const rows = (data ?? []) as DiscoverySuggestion[];
  // Frühsignale zuerst (wie im Cron), dann Score.
  return rows.sort(
    (a, b) =>
      (b.flow_state === 'dreht_auf' ? 1 : 0) - (a.flow_state === 'dreht_auf' ? 1 : 0) ||
      (b.score ?? 0) - (a.score ?? 0)
  );
}

export async function decideDiscoverySuggestion(
  symbol: string,
  status: 'uebernommen' | 'abgelehnt'
): Promise<void> {
  const { error } = await supabase
    .from('v5_discovery_suggestions')
    .update({ status, decided_at: new Date().toISOString() })
    .eq('symbol', symbol);
  if (error) throw new Error(error.message);
}
